<template>
  <div class="message-details pa-2">
    <v-row dense>
      <!-- Colonne gauche : dates -->
      <v-col cols="12" sm="6">
        <div class="detail-row">
          <v-icon color="primary" size="14">mdi-calendar</v-icon>
          <span class="detail-label">Envoyé</span>
          <span class="detail-value">{{ formatDate(msg.created_at) }}</span>
        </div>

        <div v-if="msg.first_played_at" class="detail-row">
          <v-icon color="success" size="14">mdi-ear-hearing</v-icon>
          <span class="detail-label">1ère écoute</span>
          <span class="detail-value">{{ formatDate(msg.first_played_at) }}</span>
        </div>

        <div v-if="msg.first_played_at" class="detail-row">
          <v-icon color="success" size="14">mdi-ear-hearing</v-icon>
          <span class="detail-label">Dernière écoute</span>
          <span class="detail-value">{{ formatDate(msg.last_played_at) }}</span>
        </div>
      </v-col>

      <!-- Colonne droite : stats -->
      <v-col cols="12" sm="6">
        <div v-if="msg.first_played_at" class="detail-row">
          <v-icon color="secondary" size="14">mdi-volume-high</v-icon>
          <span class="detail-label">Écouté</span>
          <v-chip color="secondary" density="compact" size="x-small" variant="tonal">
            {{ msg.play_count ?? 0 }} fois
          </v-chip>
        </div>

        <div class="detail-row">
          <v-icon color="warning" size="14">mdi-timer-sand</v-icon>
          <span class="detail-label">Expiration</span>
          <span class="detail-value">{{ humanizeDate(msg.expires_at) }}</span>
        </div>

        <div class="detail-row">
          <v-icon color="info" size="14">mdi-harddisk</v-icon>
          <span class="detail-label">Stockage</span>
          <v-chip :color="storageColor(msg.used_storage_percent)" density="compact" size="x-small" variant="tonal">
            {{ msg.used_storage_percent.toFixed(1) }}%
          </v-chip>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
  import type { Message } from '@/model/message.ts'
  import { formatDate, humanizeDate } from '@/utils/date.utils.ts'

  defineProps<{
    msg: Message
  }>()

  function storageColor (percent: number): string {
    if (percent >= 10) return 'error'
    if (percent >= 5) return 'warning'
    return 'info'
  }
</script>

<style scoped>
.message-details {
  border-radius: 8px;
}

.detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  flex-wrap: wrap;
}

.detail-label {
  font-size: 0.75rem;
  color: rgba(var(--v-theme-on-surface), 0.6);
  min-width: 80px;
  flex-shrink: 0;
}

.detail-value {
  font-size: 0.8125rem;
  font-weight: 500;
  word-break: break-word;
  min-width: 0;
}
</style>
